import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';

import ThemeButtons from '../../components/theme/ThemeButtons';
import LocalizationDropdown from '../../components/localization-dropdown/LocalizationDropdown';

const SecurityPageFooter = () => {
  const { t } = useTranslation('securityPage');

  const pathname = useLocation().pathname;

  return (
    <footer className='security-page_footer'>
      <div className='security-page_footer_links'>
        <a
          href='https://www.teamfactive.com/imprint'
          target='_blank'
          rel='noreferrer'
          className='security-page_footer-link'>
          {t('imprint')}
        </a>
        <a
          href='https://www.teamfactive.com/data-policy'
          target='_blank'
          rel='noreferrer'
          className='security-page_footer-link'>
          {t('privacy')}
        </a>
        <a href='#' target='_blank' rel='noopener' className='security-page_footer-link'>
          {t('conditions')}
        </a>
        <a
          href='https://www.teamfactive.com/contact/'
          target='_blank'
          rel='noreferrer'
          className='security-page_footer-link'>
          {t('contact')}
        </a>
        {pathname !== DEMO_AD_IMAGES_PATH ? (
          <NavLink to={DEMO_AD_IMAGES_PATH} className='security-page_footer-link'>
            {t('demoImagesRecreate')}
          </NavLink>
        ) : null}
      </div>
      <div className='security-page_footer_actions'>
        <LocalizationDropdown />

        <div className='security-page_footer_actions_divider'></div>

        <div className='security-page_footer_theme-switch'>
          <ThemeButtons />
        </div>
      </div>
    </footer>
  );
};

const DEMO_AD_IMAGES_PATH = '/ad/images/demo';

export default memo(SecurityPageFooter);
